/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from 'react';
import {
  Badge,
  Button, Col, Modal, Row,
} from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import logo from 'assets/img/logo-blue-full.png';
import { ReactComponent as IconMail } from 'assets/img/icons/mail.svg';
import { ReactComponent as IconMailOpen } from 'assets/img/icons/mail_open.svg';
import { ReactComponent as IconLock } from 'assets/img/icons/lock.svg';
import { ReactComponent as IconCog } from 'assets/img/icons/cog.svg';
import { ReactComponent as IconCircleArrowRight } from 'assets/img/icons/circle_arrow_right.svg';

type AdvanceSaleProps = {
  onClose: () => void,
  sendAdvanceSales:()=>void
};

function AdvanceSaleModal( {
  onClose,
  sendAdvanceSales,
}: AdvanceSaleProps ) {
  const { t } = useTranslation();

  return (
    <Modal
      show
      centered
      size="lg"
      onHide={onClose}
    >
      <Modal.Header className="pb-0" closeButton />
      <Modal.Body className="pt-0 pb-2">
        <div className="text-center">
          <img src={logo} height={40} alt="..." />
          <h2 className="text-primary my-2">
            ¿Desean confirmar su solicitud de retiro?
          </h2>
          <p>
            Usted está a punto de enviar una solicitud para desinvertir su participación.
            Recuerde que este proceso no garantiza una venta inmediata, ya que dependerá de las
            condiciones del mercado y la disponibilidad de compradores.
          </p>
        </div>

        <p className="mt-4">
          Una vez confirmada tu solicitud:
        </p>

        <ul className="p-0">
          <li className="d-flex align-items-center pb-3 gap-3">
            <div className="bg-primary icon--rounded">
              <IconLock />
            </div>
            <p className="text-primary m-0">La operación será sobre total de su participación.</p>
          </li>

          <li className="d-flex align-items-center pb-3 gap-3">
            <div className="bg-primary icon--rounded">
              <IconMailOpen />
            </div>
            <p className="text-primary m-0">Le mandaremos una propuesta con un precio de referencia que podrá aceptar o no.</p>
          </li>

          <li className="d-flex align-items-center pb-3 gap-3">
            <div className="bg-primary icon--rounded">
              <IconCog />
            </div>
            <p className="text-primary m-0">Nuestro equipo comenzará a gestionar la mejor opción de salida para usted.</p>
          </li>

          <li className="d-flex align-items-center gap-3">
            <div className="bg-primary icon--rounded">
              <IconMail />
            </div>
            <p className="text-primary m-0">Le notificaremos por correo electrónico sobre el avance del proceso.</p>
          </li>
        </ul>
      </Modal.Body>

      <Modal.Footer className="pb-5">
        <Button
          variant="blue"
          className="icon-right"
          onClick={sendAdvanceSales}
        >
          Confirmar solicitud
          <span className="btn-icon-rounded right">
            <IconCircleArrowRight />
          </span>
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default AdvanceSaleModal;
